var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5rem",
    height: "1.5rem",
    fill: "orange",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 4.25A4.75 4.75 0 004.25 9h1.5A3.25 3.25 0 019 5.75h7a.75.75 0 000-1.5H9zm0 14A3.25 3.25 0 015.75 15h-1.5A4.75 4.75 0 009 19.75h7a.75.75 0 000-1.5H9z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.25 5a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM19 2.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM1.25 12a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM5 9.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm14 5.5a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM16.75 19a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f7fe6fb1.svg";
export { ForwardRef as ReactComponent };